<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        prepend-icon="event"
        :error-messages="errorMessages"
        readonly
        :clearable="clearable"
        :rules="rules"
        v-on="on"
        @click:clear="date = ''"
      />
    </template>
    <v-date-picker
      v-model="date"
      first-day-of-week="1"
      no-title
      scrollable
      @input="menu = false"
    />
  </v-menu>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    clearable: {
      type: Boolean
    },
    value: {
      type: String,
      require: true
    },
    errorMessages: {
      type: Array
    },
    rules: {
      type: Array
    }
  },
  data() {
    return {
      date: '',
      dateFormatted: '',
      menu: false
    }
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date)
      this.$emit('input', this.date)
    },
    value(val) {
      this.date = val
    }
  },
  created() {
    if (this.value) {
      this.date = this.value
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    }
  }
}
</script>

<style>
/* Setting padding to 0 prevents hiding last week of the month on mobile devices */
div.v-date-picker-table > table > tbody > tr > td {
  padding: 0 !important;
}
</style>
